module.exports = __webpack_public_path__ + "static/media/man-bike@2x.c05a6213.jpg";